import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import css from './Breadcrumbs.module.scss';
import { fabricsURL, genderURLs } from '../Hero/constants'; // current breadcrumb logic: add homepage first, current page as last

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var getAllBreadcrumbs = function getAllBreadcrumbs(breadcrumbsList, customBreadcrumbNodes, genderFilter, pageTitle, showFabrics) {
  var homeBreadcrumb = [{
    title: 'Home',
    url: '/'
  }];
  var gender = genderFilter ? genderFilter.charAt(0).toUpperCase() + genderFilter.slice(1).toLowerCase() : false;
  var genderBreadcrumb = gender ? [{
    title: gender,
    url: genderURLs[gender]
  }] : [];
  var fabricsBreadcrumb = showFabrics ? [{
    title: 'Fabrics',
    url: fabricsURL
  }] : [];
  var listBreadcrumbs = breadcrumbsList ? breadcrumbsList : [];
  var customBreadcrumbs = customBreadcrumbNodes ? getCustomBreadcrumbs(customBreadcrumbNodes) : [];
  var pageBreadcrumb = [{
    title: pageTitle,
    url: window.location.pathname
  }];
  return [].concat(homeBreadcrumb, genderBreadcrumb, fabricsBreadcrumb, _toConsumableArray(listBreadcrumbs), _toConsumableArray(customBreadcrumbs), pageBreadcrumb);
};

var getCustomBreadcrumbs = function getCustomBreadcrumbs(breadcrumbs) {
  return breadcrumbs.map(function (breadcrumb) {
    var _breadcrumb$node = breadcrumb.node,
        collection = _breadcrumb$node.collection,
        customTitle = _breadcrumb$node.customTitle,
        customUrl = _breadcrumb$node.customUrl;
    var url = collection ? collection.absoluteUrl : '';
    var title = collection ? collection.title : '';
    if (url === '' && customUrl) url = customUrl;
    if (title === '' && customTitle) title = customTitle;
    return {
      title: title,
      url: url
    };
  });
};

var Breadcrumb = function Breadcrumb(_ref) {
  var isLast = _ref.isLast,
      title = _ref.title,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("li", {
    className: css.breadcrumb,
    children: [/*#__PURE__*/_jsx("a", {
      "aria-current": isLast ? 'page' : undefined,
      className: cc([css.link, _defineProperty({}, css.current, isLast)]),
      href: url,
      children: title
    }), !isLast && /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: css.divide,
      children: "/"
    })]
  });
};

Breadcrumb.propTypes = {
  isLast: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string
};

var Breadcrumbs = function Breadcrumbs(_ref3) {
  var breadcrumbsList = _ref3.breadcrumbsList,
      customBreadcrumbNodes = _ref3.customBreadcrumbNodes,
      genderFilter = _ref3.genderFilter,
      heroType = _ref3.heroType,
      pageTitle = _ref3.pageTitle,
      showFabrics = _ref3.showFabrics;
  var allBreadcrumbs = getAllBreadcrumbs(breadcrumbsList, customBreadcrumbNodes, genderFilter, pageTitle, showFabrics);
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": "breadcrumbs",
    children: /*#__PURE__*/_jsx("ol", {
      className: cc([css.root, _defineProperty({}, css.textOnlyHero, heroType === 'TEXT_ONLY')]),
      children: allBreadcrumbs.map(function (crumb, index) {
        return /*#__PURE__*/_createElement(Breadcrumb, _objectSpread(_objectSpread({}, crumb), {}, {
          key: crumb.title,
          isLast: index === allBreadcrumbs.length - 1
        }));
      })
    })
  });
};

Breadcrumbs.propTypes = {
  breadcrumbsList: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string
  })),
  customBreadcrumbNodes: PropTypes.arrayOf(PropTypes.shape()),
  genderFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  heroType: PropTypes.string,
  pageTitle: PropTypes.string.isRequired,
  showFabrics: PropTypes.bool
};
export default Breadcrumbs;